import { Plus, Trash2 } from 'lucide-react';
import { processarTextoMultiploItens } from '../utils/text-processor';
import { removerItemLista, adicionarMultiplosItensLista } from '../utils/lista-manager';
import { useI18n } from '@/contexts/i18n-hook';

interface AdequacoesTecnicasSectionProps {
  descricaoCondicaoAtual: string[];
  medidasControle: string[];
  exigenciasNormativas: string[];
  setDescricaoCondicaoAtual: (descricao: string[]) => void;
  setMedidasControle: (medidas: string[]) => void;
  setExigenciasNormativas: (exigencias: string[]) => void;
  pendingDescricao: string;
  setPendingDescricao: (v: string) => void;
  pendingMedida: string;
  setPendingMedida: (v: string) => void;
  pendingExigencia: string;
  setPendingExigencia: (v: string) => void;
}

export function AdequacoesTecnicasSection({
  descricaoCondicaoAtual,
  medidasControle,
  exigenciasNormativas,
  setDescricaoCondicaoAtual,
  setMedidasControle,
  setExigenciasNormativas,
  pendingDescricao,
  setPendingDescricao,
  pendingMedida,
  setPendingMedida,
  pendingExigencia,
  setPendingExigencia,
}: AdequacoesTecnicasSectionProps) {
  const { t } = useI18n();
  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900 mb-3">{t('apreciacaoModais.editarParte.adequacoesTecnicas.titulo')}</h2>
      
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t('apreciacaoModais.editarParte.adequacoesTecnicas.descricaoRotulo')}
          </label>
          <div className="space-y-2">
            {descricaoCondicaoAtual.map((item, index) => (
              <div key={index} className="flex items-start gap-2">
                <textarea
                  ref={(el) => { if (el) { el.style.height = 'auto'; el.style.height = el.scrollHeight + 'px'; } }}
                  rows={1}
                  value={item}
                  onChange={(e) => {
                    const novaLista = [...descricaoCondicaoAtual];
                    novaLista[index] = e.target.value;
                    setDescricaoCondicaoAtual(novaLista);
                  }}
                  onInput={(e) => { e.currentTarget.style.height = 'auto'; e.currentTarget.style.height = e.currentTarget.scrollHeight + 'px'; }}
                  style={{ resize: 'none', overflow: 'hidden' }}
                  className="flex-1 border border-gray-300 rounded-md px-3 py-2 text-sm"
                />
                <button
                  type="button"
                  onClick={() => removerItemLista(descricaoCondicaoAtual, setDescricaoCondicaoAtual, index)}
                  className="text-red-600 hover:text-red-800"
                >
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
            ))}
            <div className="flex gap-2 mt-1">
              <textarea
                rows={1}
                value={pendingDescricao}
                onChange={(e) => setPendingDescricao(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    if (pendingDescricao.trim()) {
                      setDescricaoCondicaoAtual([...descricaoCondicaoAtual, pendingDescricao.trim()]);
                      setPendingDescricao('');
                      e.currentTarget.style.height = 'auto';
                    }
                  }
                }}
                onPaste={(e) => {
                  e.preventDefault();
                  const textoColado = e.clipboardData.getData('text');
                  const itensProcessados = processarTextoMultiploItens(textoColado);
                  adicionarMultiplosItensLista(descricaoCondicaoAtual, setDescricaoCondicaoAtual, itensProcessados);
                  setPendingDescricao('');
                  e.currentTarget.style.height = 'auto';
                }}
                onInput={(e) => { e.currentTarget.style.height = 'auto'; e.currentTarget.style.height = e.currentTarget.scrollHeight + 'px'; }}
                style={{ resize: 'none', overflow: 'hidden' }}
                placeholder={t('apreciacaoModais.editarParte.listaPlaceholder')}
                className="flex-1 border border-gray-300 rounded-md px-3 py-2 text-sm"
              />
              <button
                type="button"
                onClick={() => {
                  if (pendingDescricao.trim()) {
                    setDescricaoCondicaoAtual([...descricaoCondicaoAtual, pendingDescricao.trim()]);
                    setPendingDescricao('');
                  }
                }}
                className="px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                <Plus className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t('apreciacaoModais.editarParte.adequacoesTecnicas.medidasRotulo')}
          </label>
          <div className="space-y-2">
            {medidasControle.map((item, index) => (
              <div key={index} className="flex items-start gap-2">
                <textarea
                  ref={(el) => { if (el) { el.style.height = 'auto'; el.style.height = el.scrollHeight + 'px'; } }}
                  rows={1}
                  value={item}
                  onChange={(e) => {
                    const novaLista = [...medidasControle];
                    novaLista[index] = e.target.value;
                    setMedidasControle(novaLista);
                  }}
                  onInput={(e) => { e.currentTarget.style.height = 'auto'; e.currentTarget.style.height = e.currentTarget.scrollHeight + 'px'; }}
                  style={{ resize: 'none', overflow: 'hidden' }}
                  className="flex-1 border border-gray-300 rounded-md px-3 py-2 text-sm"
                />
                <button
                  type="button"
                  onClick={() => removerItemLista(medidasControle, setMedidasControle, index)}
                  className="text-red-600 hover:text-red-800"
                >
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
            ))}
            <div className="flex gap-2 mt-1">
              <textarea
                rows={1}
                value={pendingMedida}
                onChange={(e) => setPendingMedida(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    if (pendingMedida.trim()) {
                      setMedidasControle([...medidasControle, pendingMedida.trim()]);
                      setPendingMedida('');
                      e.currentTarget.style.height = 'auto';
                    }
                  }
                }}
                onPaste={(e) => {
                  e.preventDefault();
                  const textoColado = e.clipboardData.getData('text');
                  const itensProcessados = processarTextoMultiploItens(textoColado);
                  adicionarMultiplosItensLista(medidasControle, setMedidasControle, itensProcessados);
                  setPendingMedida('');
                  e.currentTarget.style.height = 'auto';
                }}
                onInput={(e) => { e.currentTarget.style.height = 'auto'; e.currentTarget.style.height = e.currentTarget.scrollHeight + 'px'; }}
                style={{ resize: 'none', overflow: 'hidden' }}
                placeholder={t('apreciacaoModais.editarParte.listaPlaceholder')}
                className="flex-1 border border-gray-300 rounded-md px-3 py-2 text-sm"
              />
              <button
                type="button"
                onClick={() => {
                  if (pendingMedida.trim()) {
                    setMedidasControle([...medidasControle, pendingMedida.trim()]);
                    setPendingMedida('');
                  }
                }}
                className="px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                <Plus className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t('apreciacaoModais.editarParte.adequacoesTecnicas.exigenciasRotulo')}
          </label>
          <div className="space-y-2">
            {exigenciasNormativas.map((item, index) => (
              <div key={index} className="flex items-start gap-2">
                <textarea
                  ref={(el) => { if (el) { el.style.height = 'auto'; el.style.height = el.scrollHeight + 'px'; } }}
                  rows={1}
                  value={item}
                  onChange={(e) => {
                    const novaLista = [...exigenciasNormativas];
                    novaLista[index] = e.target.value;
                    setExigenciasNormativas(novaLista);
                  }}
                  onInput={(e) => { e.currentTarget.style.height = 'auto'; e.currentTarget.style.height = e.currentTarget.scrollHeight + 'px'; }}
                  style={{ resize: 'none', overflow: 'hidden' }}
                  className="flex-1 border border-gray-300 rounded-md px-3 py-2 text-sm"
                />
                <button
                  type="button"
                  onClick={() => removerItemLista(exigenciasNormativas, setExigenciasNormativas, index)}
                  className="text-red-600 hover:text-red-800"
                >
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
            ))}
            <div className="flex gap-2 mt-1">
              <textarea
                rows={1}
                value={pendingExigencia}
                onChange={(e) => setPendingExigencia(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    if (pendingExigencia.trim()) {
                      setExigenciasNormativas([...exigenciasNormativas, pendingExigencia.trim()]);
                      setPendingExigencia('');
                      e.currentTarget.style.height = 'auto';
                    }
                  }
                }}
                onPaste={(e) => {
                  e.preventDefault();
                  const textoColado = e.clipboardData.getData('text');
                  const itensProcessados = processarTextoMultiploItens(textoColado);
                  adicionarMultiplosItensLista(exigenciasNormativas, setExigenciasNormativas, itensProcessados);
                  setPendingExigencia('');
                  e.currentTarget.style.height = 'auto';
                }}
                onInput={(e) => { e.currentTarget.style.height = 'auto'; e.currentTarget.style.height = e.currentTarget.scrollHeight + 'px'; }}
                style={{ resize: 'none', overflow: 'hidden' }}
                placeholder={t('apreciacaoModais.editarParte.listaPlaceholder')}
                className="flex-1 border border-gray-300 rounded-md px-3 py-2 text-sm"
              />
              <button
                type="button"
                onClick={() => {
                  if (pendingExigencia.trim()) {
                    setExigenciasNormativas([...exigenciasNormativas, pendingExigencia.trim()]);
                    setPendingExigencia('');
                  }
                }}
                className="px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                <Plus className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

